module.exports = __webpack_public_path__ + "media/images/interactive-map-2c95f6543e25c008d213e145ad1d1cf1.jpg";